
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landlord-price-list",
      function () {
        return require("private-next-pages/landlord-price-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landlord-price-list"])
      });
    }
  